import React, {Component} from 'react'
import {isAdmin} from '../cads/is-role'
import {sumSalesOrders, sumSalesOrdersDollar, sumHold, roundToPenny} from '../cads/sum.js'
import {quantity, salesPrice} from '../cads/unminify'
import {filterShippedOrders} from './filter-sales-orders'

let space = <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

class TotalsBox extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    let {results, status, contact, shippedData, salesOrderData, fromDate, toDate, rep} = this.props

    //in progress rows are still shipped data, but admin reports treat them as their own
    //status - so keep them out of Shipped and show them separately
    const shippedOrders = results.map(b => filterShippedOrders(shippedData[b.s] || [], contact, fromDate, toDate, rep))
    const sumDollars = (orders, wantInProgress) => orders
      .filter(order => (order.i == 't') == wantInProgress)
      .reduce((total, order) => total + roundToPenny(Number(quantity(order)) * Number(salesPrice(order))), 0)

    const shippedQty = shippedOrders.reduce((a, orders) => {
      return a + orders.filter(order => order.i != 't').reduce((total, order) => total + Number(quantity(order)), 0)
    }, 0)
    const shippedDollar = shippedOrders.reduce((a, orders) => a + sumDollars(orders, false), 0)
    const inProgressDollar = shippedOrders.reduce((a, orders) => a + sumDollars(orders, true), 0)

    const poQty = status == 'PO' ? results.reduce((a, b) => {
      return a + sumSalesOrders(salesOrderData[b.s], contact, fromDate, toDate, rep) + sumSalesOrders(salesOrderData[b.i], contact, fromDate, toDate, rep)
    }, 0) : 0
    const holdQty = status == 'Hold' ? results.reduce((a, b) => {
      return a + sumHold(salesOrderData[b.s], contact, fromDate, toDate, rep) + sumHold(salesOrderData[b.i], contact, fromDate, toDate, rep)
    }, 0) : 0

    return (
      <div style={{position: 'fixed', left: 0, padding: '10px', border: '1px solid rgb(230,230,230)', borderRadius: '2px', background: 'white', bottom: 0, zIndex: 9, width: '100%', boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05)'}}>
        <b>Cads:</b> {results.length}
        {space}
        <b>On Hand:</b> {results.reduce((a, b) => a + ((b.y > 0 ? b.y : 0) || 0), 0).totalFormat()}
        {space}
        <b>ATS:</b> {results.reduce((a, b) => a + ((b.a > 0 ? b.a : 0) || 0), 0).totalFormat()}
        {space}
        <b>Future ATS:</b> {results.reduce((a, b) => a + ((b.u > 0 ? b.u : 0) || 0), 0).totalFormat()}
        {space}
        <b>Future Stock:</b> {results.reduce((a, b) => a + ((b.w > 0 ? b.w : 0) || 0), 0).totalFormat()}
        {space}
        <b>Oversold:</b> {results.reduce((a, b) => a + ((b.u > 0 ? 0 : -1 * b.u) || 0), 0).totalFormat()}
        {space}
        {
          status == 'Shipped'
          ?
          <React.Fragment>
            <b>Shipped QTY:</b> {shippedQty.totalFormat()}
            {space}
          </React.Fragment>
          :
          null
        }
        {
          isAdmin() && status == 'Shipped'
          ?
          <React.Fragment>
            <b>Shipped: $</b>
            {Math.round(shippedDollar).totalFormat()}
            {space}
            <b>In Progress: $</b>
            {Math.round(inProgressDollar).totalFormat()}
            {space}
          </React.Fragment>
          :
          null
        }
        {
          status == 'Hold'
          ?
          <React.Fragment>
            <b>Hold QTY:</b> {holdQty.totalFormat()}
            {space}
          </React.Fragment>
          :
          null
        }
        {
          status == 'PO'
          ?
          <React.Fragment>
            <b>PO QTY:</b> {poQty.totalFormat()}
            {space}
          </React.Fragment>
          :
          null
        }
        {
          isAdmin() && status == 'PO'
          ?
          <React.Fragment>
            <b>PO: $</b>
            {Math.round(results.reduce((a, b) => a + sumSalesOrdersDollar(salesOrderData[b.s], contact, fromDate, toDate, rep) + sumSalesOrdersDollar(salesOrderData[b.i], contact, fromDate, toDate, rep) , 0)).totalFormat()}
          </React.Fragment>
          :
          null
        }
      </div>
    )
  }
}

export default TotalsBox
